module.exports = __webpack_public_path__ + "img/group.d7d8fe5d.png";